import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { isDate, parseISO } from 'date-fns'

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value

    if (value && !isDate(parseISO(value))) {
      return { invalidDate: true }
    }

    return null
  }
}
